import React from "react";
import { FaListUl, FaFileAlt, FaProjectDiagram, FaLayerGroup, FaTags, FaCog, FaUserFriends } from "react-icons/fa";
import type { IconType } from "react-icons";
import { useLanguage } from "../i18n/LanguageContext";
import "./MobileTabBar.css";

export type MobileTabBarProps = {
  selectedTab: number;
  onTabSelect: (tab: number) => void;
};

/** Icons in tab order; the labels come from the language the app is in,
    so they are looked up inside the component rather than baked in here. */
const tabIcons: IconType[] = [
  FaListUl, FaFileAlt, FaProjectDiagram, FaLayerGroup, FaUserFriends, FaTags, FaCog,
];

/** The view each tab opens, in tab order — Home's mapping and this bar's
    buttons have to stay the same list or the phone opens the wrong page. */
export const MOBILE_TAB_VIEWS = [
  "notes", "documents", "discover", "storyboards", "shared", "tags", "settings",
] as const;

export const MobileTabBar: React.FC<MobileTabBarProps> = ({ selectedTab, onTabSelect }) => {
  const { t } = useLanguage();
  // Same order as MOBILE_TAB_VIEWS and tabIcons
  const labels = [
    t.nav.notes,
    t.nav.documents,
    t.nav.discover,
    t.nav.storyboardsTab,
    t.nav.shared,
    t.nav.tagManagement,
    t.nav.settings,
  ];

  return (
    <nav className="mobile-tab-bar">
      {tabIcons.map((icon, idx) => {
        const IconComponent = icon as React.ComponentType;
        const label = labels[idx];
        return (
          <button
            key={MOBILE_TAB_VIEWS[idx]}
            className={`mobile-tab-bar__button${selectedTab === idx ? " active" : ""}`}
            onClick={() => onTabSelect(idx)}
            aria-label={label}
          >
            <span className="mobile-tab-bar__icon"><IconComponent /></span>
            <span className="mobile-tab-bar__label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
};
